<template>
  <a-layout-content class="hhxc-content">
    <router-view v-slot="{ Component, route }">
      <!-- <transition mode="out-in" name="fade-transform" appear> -->
      <keep-alive :max="keepAliveMaxNum">
        <component v-if="route.meta.keepAlive" :is="Component" :key="route.name" />
      </keep-alive>
      <component v-if="!route.meta.keepAlive" :is="Component" :key="route.fullPath" />
      <!-- </transition> -->
    </router-view>
  </a-layout-content>
</template>

<script>
  import CONFIG from '@/config'
  import { computed, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'

  export default {
    name: 'HhxcContent',
    setup(props) {
      const route = useRoute()
      const store = useStore()
      const keepAliveMaxNum = computed(() => {
        const max = Number(CONFIG.keepAliveMaxNum)
        return Number.isFinite(max) && max > 0 ? max : undefined
      })
      watch(
        route,
        () => {
          if ('mobile' === props.device) {
            store.dispatch('settings/foldSideBar')
          }
        },
        { immediate: true }
      )
      return { keepAliveMaxNum }
    },
  }
</script>

<style lang="less">
  .fade-transform-enter-active,
  .fade-transform-leave-active {
    transition: all 0.2s ease-out;
  }

  .fade-transform-leave-active {
    position: absolute;
  }

  .fade-transform-enter-from,
  .fade-transform-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }

  .hhxc-content {
    // min-height: calc(
    //   100vh - @hhxc-header-height - @hhxc-padding - @hhxc-padding -
    //     @hhxc-padding
    // ) !important;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: auto;
    // margin: 8px;
    padding: 8px;
    // margin-top: 42px;
    // background: #ffffff;
    .error-container {
      height: calc(100vh - @hhxc-header-height - @hhxc-padding - @hhxc-padding - @hhxc-padding - @hhxc-padding - @hhxc-padding - 20px) !important;
    }
  }
</style>
